import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import CustomModal from "../../basics/interface/CustomModal"
import { COLORS } from "../../../utilities/Constants"
import { filterEmployesActifs } from "../../../utilities/employes"

// Sortie d'une commande de stock virtuel vers un employé (commande perso).
const CmdPersoModalV2 = ({
	commande,
	employes,
	postState,
	onConsommer,
	onClose,
}) => {
	const [employe, setEmploye] = useState(0)
	const busy = postState.saving || postState.saved

	return (
		<CustomModal
			title="Commande personnelle"
			subtitle={commande ? commande.fournisseur_nom : ""}
			onClose={onClose}
			showCloseButton={!busy}
			showFooter={!busy}
			buttons={[
				{ title: "Annuler", styleName: "secondary", onClick: onClose },
				{
					title: "Sortir du stock",
					styleName: "primary",
					onClick: () => onConsommer(employe, commande.id),
					disabled: employe === 0,
				},
			]}
		>
			{busy ? (
				<div style={s.feedback}>
					{postState.saving ? (
						<FontAwesomeIcon icon={faSync} spin size="2x" />
					) : (
						<FontAwesomeIcon
							icon={faCheck}
							size="2x"
							style={{ color: COLORS.success }}
						/>
					)}
				</div>
			) : (
				<div style={s.field}>
					<span style={s.label}>Employé</span>
					<select
						style={s.input}
						value={employe}
						onChange={(e) => setEmploye(parseInt(e.target.value))}
					>
						<option value={0}>-</option>
						{filterEmployesActifs(employes).map((emp) => (
							<option key={emp.id} value={emp.id}>
								{emp.nom}
							</option>
						))}
					</select>
				</div>
			)}
		</CustomModal>
	)
}

const s = {
	feedback: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: "24px 0",
		color: COLORS.textMuted,
	},
	field: { display: "flex", flexDirection: "column", marginBottom: 14 },
	label: {
		fontSize: 12,
		fontWeight: 600,
		color: COLORS.textMuted,
		marginBottom: 6,
	},
	input: {
		height: 38,
		padding: "0 12px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		fontSize: 14,
		color: COLORS.text,
		fontFamily: "inherit",
		backgroundColor: COLORS.surface,
		boxSizing: "border-box",
	},
}

export default CmdPersoModalV2
